module.exports = __webpack_public_path__ + "static/media/20_genderless.e1673f18.jpg";